import { useTranslation } from "react-i18next";
import HollowButton from "components/HollowButton";
import LoadingScreen from "components/LoadingScreen";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import styles from "./styles.module.scss";
import AuthLayout from "components/AuthLayout";
import settingsService from "api/settingsService";
import Button from "components/Button";

export enum TransferAdeModuleSteps {
  Question = "question",
  NotFound = "notFound",
  Confirmed = "confirmed",
  Rejected = "rejected",
}

const TransferAdeModule = () => {
  const { t } = useTranslation();
  // const isInvitation = auth?.user?.profile?.invitation ?? null;
  const navigate = useNavigate();
  const { ade } = useParams();

  const {
    data: recoveryPackage,
    isLoading: isLoadingRecoveryPackage,
    isSuccess: isSuccessRecoveryPackage,
  } = settingsService.useGetEDeliveryTransfer(ade);

  const [step, setStep] = useState<string | null>(null);

  const handleNextStep = () => {
    setStep(TransferAdeModuleSteps.Confirmed);
  };

  const handleSkipStep = () => {
    setStep(TransferAdeModuleSteps.Rejected);
  };

  const gotoNota = () => {
    navigate("/");
  };

  useEffect(() => {
    if (isSuccessRecoveryPackage) {
      setStep(TransferAdeModuleSteps.Question);
    } else {
      setStep(TransferAdeModuleSteps.NotFound);
    }
  }, [recoveryPackage]);

  if (isLoadingRecoveryPackage) {
    return <LoadingScreen></LoadingScreen>;
  }

  return (
    <AuthLayout actualStep={1} steps={[]}>
      <>
        {step === TransferAdeModuleSteps.Question && (
          <div className={styles.wrapper2}>
            <div className={styles.header}>
              {t("transfer.confirmTitle")}
            </div>
            {t("transfer.requestReceived")}{" "}
            <b>{recoveryPackage.data?.Ade}</b> do innego operatora. <br></br>
            <br></br>
            <b>
              {t("transfer.confirmInstruction")}
            </b>
            <br></br>
            {t("transfer.confirmQuestion")}
            <div className={styles.buttons}>
              <HollowButton
                className={styles.button}
                text={t("transfer.rejectBtn")}
                onClick={() => handleSkipStep?.()}
              ></HollowButton>
              <Button
                className={styles.button}
                text={t("transfer.confirmBtn")}
                onClick={() => handleNextStep?.()}
              ></Button>
            </div>
          </div>
        )}
        {step === TransferAdeModuleSteps.NotFound && (
          <div className={styles.wrapper2}>
            <div className={styles.header}>{t("errors.noActiveTransfer")}</div>
            {t("errors.noActiveTransfer")}
            <div className={styles.buttons}>
              <Button
                className={styles.button}
                text={t("transfer.goToNota")}
                onClick={() => gotoNota?.()}
              ></Button>
            </div>
          </div>
        )}
        {step === TransferAdeModuleSteps.Confirmed && (
          <div className={styles.wrapper2}>
            <div className={styles.header}>{t("transfer.confirmedTitle")}</div>
            {t("transfer.confirmedMessage")}
            <br></br>
            <br></br>
            {t("transfer.soonTransferred")}
            <div className={styles.buttons}>
              <Button
                className={styles.button}
                text={t("transfer.goToNota")}
                onClick={() => gotoNota?.()}
              ></Button>
            </div>
          </div>
        )}
        {step === TransferAdeModuleSteps.Rejected && (
          <div className={styles.wrapper2}>
            <div className={styles.header}>{t("transfer.rejectedTitle")}</div>
            {t("transfer.rejectedMessage")}
            <br></br>
            <br></br>
            {t("transfer.noChanges")}
            <div className={styles.buttons}>
              <Button
                className={styles.button}
                text={t("transfer.goToNota")}
                onClick={() => handleNextStep?.()}
              ></Button>
            </div>
          </div>
        )}
      </>
    </AuthLayout>
  );
};
export default TransferAdeModule;
